// extracted by mini-css-extract-plugin
module.exports = {"root":"HeadingBlock_root__ui_3c","visible":"HeadingBlock_visible__3Lp8I","positioner":"HeadingBlock_positioner__NQHuw","subTitle":"HeadingBlock_subTitle__LuhNd"};